<template>
    <v-card flat class="mt-2">
		<v-alert v-if="data.flag_end == '1'" dense shaped type="error">Non Aktif</v-alert>
        <judul-praktik :data="data"></judul-praktik>

        <v-card-title>
            <h4>Upload Surat Selesai Praktik :</h4>
        </v-card-title>
        <v-simple-table dense>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            No
                        </th>
                        <th class="text-left">
                            Nama
                        </th>
                        <th class="text-left">
                            Surat Selesai Praktik
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in siswas" v-bind:key="item.id">
                        <td>{{ parseInt(index) + 1 }}</td>
                        <td>{{ item.nama }}</td>
                        <td><upload-surat-selesai-praktik :flag_end="data.flag_end" :praktik_id="item.praktik_id"
                                :user_id="item.user_id"></upload-surat-selesai-praktik>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
import UploadSuratSelesaiPraktik from '@/components/upload/UploadSuratSelesaiPraktik.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
import JudulPraktik from '@/components/JudulPraktik.vue'

// const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        UploadSuratSelesaiPraktik,
        JudulPraktik
    },
    data() {
        return {
            praktik_id: this.$route.params.praktik_id,
            data: {
                nama_institusi: '',
                nama_prodi: '',
                profesi: '',
                stase: '',
                tanggal_awal: '',
                tanggal_akhir: '',
            },
            dokumens: [],
            siswas: [],
        }
    },
    computed: {
        headers() {
            return {
                Authorization: this.$store.state.token,
            }
        },
        user() {
            return this.$store.getters.user
        },
    },
    created() {
        this.getDetail()
    },
    methods: {
        getDetail() {
            const fmData = new FormData()
            fmData.append('id', this.praktik_id)
            axiosPostAuth('api/Praktik/getPraktik', fmData)
                .then(response => {
                    this.data = Object.assign({}, response.data)
                    this.getData()
                })
                .catch(error => {
                    alert(error)
                })
        },
        getData() {
            let fmData = new FormData();
            fmData.append('praktik_id', this.praktik_id)
            fmData.append('kategori', this.data.profesi)
            axiosPostAuth('api/SelesaiPraktik/getSiswa', fmData)
                .then(response => {
                    this.siswas = response.data
                })
        },
    },
}
</script>